import { Mandala } from "./Mandala";
import { weddingConfig } from "../config/weddingConfig";

// Ornate arched frame used for every avatar slot on the site.
// When an `image` path is supplied through weddingConfig the illustration is
// rendered (lazy-loaded); until then an emerald-and-gold AZ monogram
// placeholder marks the slot.
export const MonogramFrame = ({
  image,
  alt,
  label,
  testId,
  small = false,
  className = "",
}) => {
  const { initials } = weddingConfig.couple;

  return (
    <div data-testid={testId} className={`relative ${className}`}>
      {/* ================================================================
          IMAGE SLOT — the illustration path comes from weddingConfig.
          Set the matching `image` field there (e.g. "/images/haldi.png").
          ================================================================ */}
      <div className="rounded-t-full border border-gold/60 bg-emerald-deep/60 p-1.5 shadow-[0_24px_60px_-16px_rgba(0,0,0,0.5)]">
        <div className="relative overflow-hidden rounded-t-full border border-gold/40">
          {image ? (
            <img
              src={image}
              alt={alt}
              loading="lazy"
              decoding="async"
              className="block aspect-[3/4] w-full object-cover"
            />
          ) : (
            <div className="relative flex aspect-[3/4] w-full items-center justify-center overflow-hidden bg-emerald-light/40">
              <Mandala className="absolute left-1/2 top-1/2 h-[170%] w-[170%] -translate-x-1/2 -translate-y-1/2 text-gold/20" />
              <span
                className={`relative font-serif tracking-[0.15em] text-gold-bright ${
                  small ? "text-2xl" : "text-4xl"
                }`}
              >
                {initials}
              </span>
              {label && (
                <span
                  className={`absolute bottom-4 left-0 right-0 text-center font-sans uppercase tracking-[0.3em] text-gold/60 ${
                    small ? "text-[7px]" : "text-[8px]"
                  }`}
                >
                  {label}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
